<template>

    <div class="bg-gray-50">
      <div class="relative overflow-hidden">

        <div class="relative pt-6 pb-16 sm:pb-24">
            <!-- Header section -->
            <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">


                <div class="bg-gray-900 rounded">
                <div class="pt-12 sm:pt-16 lg:pt-24">
                    <div class="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
                    <div class="max-w-3xl mx-auto space-y-2 lg:max-w-none">
                        <h2 class="text-lg leading-6 font-semibold text-gray-300 uppercase tracking-wider">
                        Login Form
                        </h2>
                        <p class="text-3xl font-extrabold text-white sm:text-4xl lg:text-5xl">
                          Sign in to your account
                        </p>

                    </div>
                    </div>
                </div>
                <div class="mt-8 pb-12 bg-gray-50 sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24">
                    <div class="relative">
                      <div class="absolute inset-0 h-3/4 bg-gray-900"></div>
                        <div class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                   
                                <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                                    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                                      <v-form ref="form" class="space-y-6" v-model="valid">
                                        
                                            <v-text-field
                                              v-model="form.email"
                                              :rules="[v => !!v || 'Email is required']"
                                              label="E-mail"
                                              required
                                            >
                                            </v-text-field>
                                            <span class="text-danger" v-if="errors.email">
                                              {{ errors.email[0] }}
                                            </span>

                                            <v-text-field
                                              v-model="form.password"
                                              :rules="[v => !!v || 'password is required']"
                                              type="password"
                                              label="Password"
                                              required
                                            >
                                            </v-text-field>
                                            <span class="text-danger" v-if="errors.password">
                                              {{ errors.password[0] }}
                                            </span>

                                            <v-btn
                                              :disabled="!valid"
                                              color="info"
                                              class="mr-4"
                                              @click="login"
                                            >
                                              Login
                                            </v-btn>
                                        </v-form>

                                    </div>
                                </div>
         
                        </div>
                    </div>

                </div>
                </div>

            </div>

        </div>


      </div>

    </div>
</template>

<script>
export default {
  data() {
    return {

      valid: true,
      form: {
        email: "",
        password: ""
      },
      errors: []

    };
  },

  methods: {
      goHome() {
       this.$router.push({ name: "Home" },);
    
    },

    goLogin() {
       this.$router.push({ name: "Login" },);
    
    },

    login() {
      this.$store
        .dispatch("login", this.form)
        .then(() => {
          this.$router.push({ name: "Home" });
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    }

  }
};
</script>
